var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCondense = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m10 15 12 13.2L34 15",
  stroke: "#fff",
  strokeWidth: 2
})));

export { SvgCondense as ReactComponent };
export default __webpack_public_path__ + "aae01ce5e85559210f1db97609d411ea.svg";